// 这里主要是用来初始化flutter所需要的全局方法
import store from "@/store"
window.getAppInfo = function (obj) {
    if (obj) {
        localStorage.setItem('APP_INFO', obj)
        store.commit('SET_APP_INFO', JSON.parse(obj))
    }
}